//one-comp-medication/card.tsx
import * as React from 'react';
import Table from "antd/lib/table";

import {
  Card
} from 'one-ui-card/src/card';

import {
  MedicationCardProps
} from './props';

import {
  MedicationModal
} from './model';

import {
  checkCardHasError,
  TabErrorMsg
} from 'one-card-notification';

/**
 *  card renders all Medication of patient related data
 * @param props component properties
 *
 */
export const MedicationCard = <M extends MedicationModal>(
  props: MedicationCardProps<M>
) => {
  const {
    model,
  } = props;

  const {
    medication,
  } = model || {};
  let medicationUIBody;
  const columns = [
    {
      title: "Name",
      dataIndex: "name",
      key: "name"
    },
    {
      title: "PatientSig",
      dataIndex: "patientsig",
      key: "patientsig"
    },
    {
      title: "Start Date",
      dataIndex: "startdate",
      key: "start"
    },
    {
      title: "End Date",
      key: "enddate",
      dataIndex: "enddate"
    },
    {
      title: "Refills Remaining",
      key: "refillsremaining",
      dataIndex: "refillsremaining"
    }
  ];

  // To Check for the Error from the API
  if (checkCardHasError("Medication") && medication.length === 0) {
    medicationUIBody =
      <>
        <TabErrorMsg />
      </>
  }
  else {
    medicationUIBody =
      <>
        <Table columns={columns} dataSource={medication}
          size={'small'}
          pagination={{ defaultPageSize: 4, showSizeChanger: false }}
        />
      </>
  }

  return (
    <Card
      title=""
      body={medicationUIBody}
    />
  );
};
